import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { I18nPipe } from './i18n/i18n.pipe';
import { SafePipe } from './safe/safe.pipe';
import { PhonePipe } from './phonePipe/phone.pipe';
import { KeysPipe } from './keyValue/key.pipe';
import { CnpjPipe } from './cnpjPipe/cnpj.pipe';
import { JactoCurrency } from './jactoCurrency/jactoCurrency.pipe';
import { CpfPipe } from './cpfPipe/cpfPipe.pipe';
import { CepPipe } from './cepPipe/cep.pipe';
import { RgPipe } from './rg/rg.pipe';
import { ConvertHeightPipe } from './convertHeightPipe/convert-height.pipe';

@NgModule({
  declarations: [
    I18nPipe,
    SafePipe,
    PhonePipe,
    KeysPipe,
    CnpjPipe,
    JactoCurrency,
    CpfPipe,
    CepPipe,
    RgPipe,
    ConvertHeightPipe,
  ],
  imports: [IonicModule, CommonModule],
  exports: [
    I18nPipe,
    SafePipe,
    PhonePipe,
    KeysPipe,
    CnpjPipe,
    JactoCurrency,
    DatePipe,
    CurrencyPipe,
    CpfPipe,
    CepPipe,
    RgPipe,
    ConvertHeightPipe,
  ],
  providers: [
    I18nPipe,
    SafePipe,
    PhonePipe,
    KeysPipe,
    CnpjPipe,
    JactoCurrency,
    DatePipe,
    CurrencyPipe,
    CpfPipe,
    RgPipe,
    ConvertHeightPipe,
  ],
})
export class PipesModule {}
